/**
 * Collapse
 */

import Collapse from 'bootstrap/js/dist/collapse.js'

export default (() => {
  const collapseElementList = document.querySelectorAll('.collapse')

  /* eslint-disable no-unused-vars */
  const collapseList = [...collapseElementList].map((collapseEl) => new Collapse(collapseEl, { toggle: false }))
  /* eslint-enable no-unused-vars */
})()
